var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "z-copyright" }, [
    _vm.textBefore
      ? _c("span", { staticClass: "z-copyright__text" }, [
          _vm._v("\n        " + _vm._s(_vm.textBefore) + "\n    "),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("span", [_vm._v("©")]),
    _vm._v(" "),
    _c("span", { staticClass: "z-copyright__years" }, [
      _vm.year
        ? _c("span", { staticClass: "z-copyright__year-start" }, [
            _vm._v("\n            " + _vm._s(this.year) + "\n        "),
          ])
        : _vm._e(),
      _vm._v("\n        " + _vm._s(_vm.hyphen) + "\n\n    "),
    ]),
    _vm._v(" "),
    _vm.textAfter
      ? _c("span", { staticClass: "z-copyright__text" }, [
          _vm._v("\n        " + _vm._s(_vm.textAfter) + ",\n    "),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.yearCurrent
      ? _c("span", { staticClass: "z-copyright__year-current" }, [
          _vm._v("\n            " + _vm._s(_vm.currentYear) + "\n    "),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }